"use strict";
/**
 * THIS ENUM NEEDS TO BE REMOVED WHEN CUSTOMIZED CHARGE CATEGORIES ARE IMPLEMENTED
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ChargeCategories;
(function (ChargeCategories) {
    ChargeCategories["storage"] = "storage";
    ChargeCategories["handling"] = "handling";
    ChargeCategories["freightPrepaid"] = "freightPrepaid";
    ChargeCategories["freightThirdParty"] = "freightThirdParty";
    ChargeCategories["specialCharges"] = "specialCharges";
    ChargeCategories["materials"] = "materials";
    ChargeCategories["general"] = "general";
    ChargeCategories["custom"] = "custom";
    ChargeCategories["skuBasedStorage"] = "sku based storage";
    ChargeCategories["skuBasedHandling"] = "sku based handling";
    ChargeCategories["recurringStorage"] = "recurring storage";
})(ChargeCategories || (ChargeCategories = {}));
exports.default = ChargeCategories;
